import { render, staticRenderFns } from "./yearly_area_brand.vue?vue&type=template&id=6c993128&scoped=true"
import script from "./yearly_area_brand.vue?vue&type=script&lang=js"
export * from "./yearly_area_brand.vue?vue&type=script&lang=js"
import style0 from "./yearly_area_brand.vue?vue&type=style&index=0&id=6c993128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c993128",
  null
  
)

export default component.exports